import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let DeleteImportDataDialogComponent = {
    selector: "vcDeleteImportDataDialog",
    templateUrl:
        "/angular/components/voter-file/delete-import-data.component.html",
    bindings: {
        import: "=",
    },
    controller: class DeleteImportDataDialogController {
        // * bindings for typescript compiler *
        public import: any;
        // ************************************

        private readonly dialog: DialogUtils;
        private readonly __env: any;

        public isLeaderView: boolean;
        public confirm_text = "";
        public stats: any;

        constructor(DialogUtils: DialogUtils, __env: any, __app_type: string) {
            this.dialog = DialogUtils;
            this.__env = __env;

            this.isLeaderView = __app_type === "LEADER";
        }

        confirm(): void {
            this.dialog.hide();
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("voterFile")
    .component(
        DeleteImportDataDialogComponent.selector,
        DeleteImportDataDialogComponent
    );
